
import { EventsCard } from '@/components/pages/events/EventsCard'
import { EventData } from '@/types/event'
import Link from 'next/link'
import link from '@/lib/localEndPoints'
interface Props {
    events: EventData[]
}

export function RecentEvents(props: Props) {
    const { events } = props

    return (
        <section>
            {events.length >= 5 ? (
                <div className=" ">
                    {/* Left side */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-4 lg:mb-8">
                        {events.slice(0, 2).map((event: EventData) => (
                            <Link href={`${link.EVENT}/${event.slug}`} key={event.id}>
                                <EventsCard {...event} />
                            </Link>
                        ))}
                    </div>

                    {/* Right side - next 3 */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-8 ">
                        {events.slice(2, 5).map((event) => (
                            <div key={event.id} className="">
                                <Link href={`${link.EVENT}/${event.slug}`}>
                                    <EventsCard {...event} />
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                // If less than 5 events, just show them in a simple grid
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
                    {events.map((event) => (
                        <Link href={`${link.EVENT}/${event.slug}`} key={event.id}>
                            <div className="h-52 md:h-64">
                                <EventsCard {...event} />
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </section>
    )
}

